import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.banner';

const translations = {
    'banner': 'Bannerek',
    'id.title': 'ID',
    'create.title': 'Banner létrehozása',
    'bannerCreate': 'Banner létrehozása',
    'edit.title': 'Banner szerkesztése',
    'name.title': 'Név',
    'active_from.title': 'Megjelenés -tól',
    'active_to.title': 'Megjelenés -ig',
    'is_active.title': 'Aktív',
    'url.title': 'Url',
    'url_target.title': 'Megnyitás helye',
    'image_url_desktop.title': 'Kép (Desktop)',
    'image_url_desktop.hint': 'Méret: {size}',
    'image_url_mobile.title': 'Kép (Mobil)',
    'image_url_mobile.hint': 'Méret: {size}',
    'priority.title': 'Sorrend',
    'priority.hint': 'A magasabb értékű banner/slider jelenik meg előbb.',
    'banner_place_ids.title': 'Bannerhelyek',
    'banner_place_name.title': 'Bannerhelyek',
    'selectBannerPlace': 'Válassz bannerhelyet!',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/Banner/lang/hu.ts